import RemoveIcon from '@mui/icons-material/Remove';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import InputAdornment from '@mui/material/InputAdornment';
import { useSelector } from 'react-redux';

import Header from "../../components/header";
import LeftMenu from "../../components/left-menu";
import Grid from '@mui/material/Grid';
import "./style.css";
import TextareaAutosize from '@mui/material/TextareaAutosize';
import React, {Component} from 'react';
import {saveAs} from 'file-saver';
import axios from "axios";
import { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import download from 'js-file-download';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import NumberFormat from 'react-number-format';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import AddIcon from '@mui/icons-material/Add';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { purple } from '@mui/material/colors';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useNavigate, useLocation } from 'react-router-dom';
import LinearProgress from '@mui/material/LinearProgress';


const product = [
    { product: 'Virtual Office Plain Package', type: 'sewa'},
    { product: 'Virtual Office Public Package', type: 'sewa'},
    { product: 'Virtual Office Premium Package', type: 'sewa'},
    { product: 'Virtual Office Prestige Package', type: 'sewa'},
    { product: 'Private Office', type: 'sewa'},
    { product: 'Pendirian PT', type: 'non-sewa'},
    { product: 'Pendirian CV', type: 'non-sewa'},
    { product: 'Meeting Room', type: 'sewa'},
  ];


  
  const RedButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText(purple[500]),
    backgroundColor: "#ff0000",
    '&:hover': {
      backgroundColor: "#8b0000",
    },
  }));

const NumberFormatCustom = React.forwardRef(function NumberFormatCustom(props, ref) {
    const { onChange, ...other } = props;
  
    return (
      <NumberFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        thousandSeparator
        isNumericString
        prefix="Rp."
      />
    );
  });

export default function ProformaInvoice(){
    const passed = useLocation();

    const [totalDate,setTotalDate] = useState("")
    const [bDate,setbDate] = useState(Date())
    const [piAmount, setPIAmount] = useState("0")
    var piMonth = new Date(bDate).getMonth()+1
    var piYear = new Date(bDate).getYear()+1900
    var piDate = new Date(bDate).getDate()
    var longMonth = piMonth.toLocaleString('default', { month: 'long' })
    var piNum = "loading..."
    const [piNumb,setPINumb] = useState(piNum)
    const navigate = useNavigate();

    function toMonthName(monthNumber){
        const datedate = new Date();
        datedate.setMonth(monthNumber - 1);

        return datedate.toLocaleString('default', {
            month: 'long',
          });
    }

    const trial = () => {
        const cariJumlahnya = "ProformaInvoice"
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/cariJumlah`,{
            cariJumlahnya
        }).then(response=>{
            console.log(response.data)
          piAmount = response.data;
      });
        setPINumb(piYear+"."+piMonth+"-PI-ZANIO."+piAmount)
        setTotalDate(piDate + " " + toMonthName(longMonth) + " " + piYear)
        console.log(piDate + " " + toMonthName(longMonth) + " " + piYear)


    }
    const [test,setTest] = useState("")
    const [address1,setAddress1] = useState("")
    const [address2,setAddress2] = useState("")
    const [address3,setAddress3] = useState("")
    const [pph42Visibility,setPPH42Visibility] = useState("hidden")
    const [pph23Visibility,setPPH23Visibility] = useState("hidden")
    const [phone,setPhone] = useState("")
    const [categorias, setCategorias] = useState([]);
    const [notes, setNotes] = useState("");
    const [alamatOptions, setAlamatOptions] = useState([]);
    const [focus,setFocus] = useState("");
    const [alamatStatus,setAlamatStatus] = useState("");
    const [alamatMessage, setAlamatMessage] = useState("");
    const [open, setOpen] = React.useState(false);
    const [dpNotes,setDPNotes] = useState("hidden")
    const [pelunasanNotes,setPelunasanNotes] = useState("hidden")
    const [inquiryNum, setInquiryNum] = useState()
        const getCategorias = async () => {
          axios.get(`${process.env.REACT_APP_BACKEND_URL}/addressOptions`,{
          }).then(response=>{
            setCategorias(response.data.pilihanAlamat);
        });
          //console.log(res);
        }
        useEffect(() => {
            getCategorias();
            if (passed.state.stuff === "new"){
                trial();
                setInquiryNum(passed.state.InquiryPhoneNumber)
            }
            else{
            console.log(passed.state.data.inputFields?.length)
            setInputFields(passed.state.data.inputFields);
            // for(var i = 0; i < passed.state.data.inputFields?.length;i++){
            //     const values =[...inputFields];
            //     values[i].Description = passed.state.data.inputFields[i].Description;
            //     setInputFields(values);
            // }
            // const values =[...inputFields];
            //     values[0].Description = "test";
            //     setInputFields(values);
            setSellerID(passed.state.data.sellerID?? "PT. SUPARDI NETHANEL HUSAIN")
            setInquiryNum(passed.state.data.inquiryNum)
            setAddress1(passed.state.data.address1);
            setAddress2(passed.state.data.address2);
            setAddress3(passed.state.data.address3);
            setPhone(passed.state.data.phone);
            setNotes(passed.state.data.notes);
            setInstruction(passed.state.data.instruction);
            if(passed.state.data.instruction === "Deposit"){
                setPPNVisibility("hidden") 
            }
            if(passed.state.data.instruction === "DP"){
                setDPNotes("")
            }else{
                if(passed.state.data.instruction === "Pelunasan"){
                    setDPNotes("")
                }
            }
        
            setppnPercent(passed.state.data.ppnPercent)
            setPIAmount(passed.state.data.piAmount)
            setbDate(passed.state.data.tanggalPI)
            var piMonthly = new Date(passed.state.data.tanggalPI).getMonth()+1
            var piYearly = new Date(passed.state.data.tanggalPI).getYear()+1900
            setPINumb(piYearly+"."+piMonthly+"-PI-ZANIO."+passed.state.data.piAmount)
            setDownPayments(passed.state.data.downPayments);
            setPPN(passed.state.data.ppn);
            setSubTotal(passed.state.data.subTotal);
            setGrandTotal(passed.state.data.grandTotal);
            setbillTo(passed.state.data.billTo);
            setshipTo(passed.state.data.shipTo);
            setTotalDate(passed.state.data.tanggalPI)
        }
       }, []);
        
       const nowstate = useSelector(state => state);

    const [inputFields,setInputFields] = useState([
        {Quantity:'', QuantityStatus:false, QuantityMessage:null, Unit:'Unit',Description:'', DescriptionStatus:false, DescriptionMessage:null,UnitPrice:'',  UnitPriceStatus:false, UnitPriceMessage:null, Total:'', TotalPPN:'', Tipe:'', TipeStatus:false},
    ]);

    const [downPayments,setDownPayments] = useState([
        {SubTotal:'', GrandTotal:'', Text:'Down Payment', visibility:"", Total:"", GrandTotal:""},
    ]);

    const [pelunasansSubTotal,setPelunasansSubTotal] = useState();
    const [pelunasansGrandTotal,setPelunasansGrandTotal] = useState();

    const [billTo,setbillTo] = useState("");
    const [billtoStatus,setbilltoStatus] = useState("");
    const [billtoMessage,setbilltoMessage] = useState("");
    const [shipTo,setshipTo] = useState("");
    const [shiptoStatus,setshiptoStatus] = useState("");
    const [shiptoMessage,setshiptotoMessage] = useState("");
    const [instruction,setInstruction] = useState("");
    const [instructionStatus,setinstructionStatus] = useState("");
    const [instructionMessage,setinstructionMessage] = useState("");
    const [ppnPercent,setppnPercent] = useState(parseInt("11%"));
    const [fullPayment,setFullPayment] = useState("");
    const [fullPaymentPPN,setFullPaymentPPN] = useState("");
    const [ppnVisibility,setPPNVisibility] = useState("");
    const [loadVisibility, setLoadVisibility] = useState(false)


    const handleInstruction = (event) => {
        setInstruction(event.target.value);
        var subTotal = 0
        var grandTotal = 0
        setTimeout(() => { 
        for (var i  = 0; i < inputFields.length; i++){
            var subtotalI = inputFields[i].Total
            var grandTotalI = inputFields[i].TotalPPN

            if(subtotalI === '' || subtotalI === 0){
                subtotalI = 0 ;
            }

            if(grandTotalI === '' || grandTotalI === 0){
                grandTotalI = 0 ;
            }

            subTotal  += parseFloat(subtotalI);
            grandTotal  += parseFloat(grandTotalI);
            

         }
        subTotal = Math.floor((subTotal)*100)/100
        grandTotal = Math.floor((grandTotal)*100)/100
        setGrandTotal(grandTotal)
        setSubTotal(subTotal)
        var ppn = Math.floor(grandTotal*100 - subTotal*100)/100
        setPPN(ppn)

        if (event.target.value === "Deposit"){
        setSubTotal(subTotal)
        setGrandTotal(subTotal)
        var ppn = ""
        setPPN(ppn)
        setPPNVisibility("hidden")
        }else{
            setPPNVisibility("")
        }

        if(event.target.value === "DP"){
            setDPNotes("")
            for (var i  = 0; i < downPayments.length-1; i++){
                const values = [...downPayments]
                values[i].Text = 'Paid Payment' + " " + parseInt(i+1);
                setDownPayments(values)
            }
            const values = [...downPayments]
            values[i].Text = 'Down Payment' + " " + parseInt(i+1);
            setDownPayments(values)
        }else{
            setDPNotes("hidden")
        }
        if(event.target.value === "Pelunasan"){
            setPelunasanNotes("")
            setDPNotes("")
            for (var i  = 0; i < downPayments.length+1; i++){
                const values = [...downPayments]
                values[i].Text = 'Paid Payment' + " " + parseInt(i+1);
                setDownPayments(values)
            }
        }else{
            setPelunasanNotes("hidden")
        }
    }, 100);
    const values =[...inputFields];
    var pph42Count = 0
    var pph23Count = 0
    if (event.target.value === "Deposit"){
    }else{
    for (var i  = 0; i < values.length; i++){
        var TipeI = values[i].Tipe
        var currTotal = values[i].Total
        console.log(TipeI)
        if(TipeI == "Sewa"){
            pph42Count = pph42Count + (currTotal * 0.1)
        }

        if(TipeI == "Non-Sewa"){
            pph23Count = pph23Count + (currTotal * 0.02)
        }
        

     }
    }
    
    setTotalPPH42(pph42Count)
    setTotalPPH23(pph23Count)

    if(pph42Count === 0){
        setPPH42Visibility("hidden")
    }else{
        setPPH42Visibility("")
    }

    if(pph23Count === 0){
        setPPH23Visibility("hidden")
    }else{
        setPPH23Visibility("")
    }
    setInputFields(values);
    };

    const handleBillTo = (event) => {
        setbillTo(event.target.value);
    };

    const handleShipTo = (event) => {
        setshipTo(event.target.value);
    };

    const [error,setError] = useState();

    const handleClose = () => {
        setOpen(false);
      };

    async function createAndDownloadPdf(e){
        setLoadVisibility(true)
            //////////////////////Update PI//////////////////////////
            var statuspass = "pass"
        const inputField =[...inputFields];
        console.log(ppnPercent)
        if(ppnPercent === "" || isNaN(ppnPercent)){
            console.log("ppn kosong")
            setError("PPN Tidak boleh kosong");
            statuspass = "tidak pass"
        }
        if(address1 === ""){
            setAlamatStatus(true);
            setAlamatMessage("Belum dipilih")
            statuspass = "tidak pass"
        }else{
            setAlamatStatus(false)
            setAlamatMessage(null)
        }
        for(var i  = 0; i < inputFields.length; i++){
            if(inputFields[i].Quantity === ""){
                inputField[i].QuantityStatus = true
                inputField[i].QuantityMessage = "Belum Diisi"
                statuspass = "tidak pass"
            }else{
                inputField[i].QuantityStatus = false
                inputField[i].QuantityMessage = null
            }
            if(inputFields[i].Unit === ""){
                inputField[i].UnitStatus = true
                inputField[i].UnitMessage = "Belum Diisi"
                statuspass = "tidak pass"
            }else{
                inputField[i].UnitStatus = false 
                inputField[i].UnitMessage = null
            }
            if(inputFields[i].Description === ""){
                inputField[i].DescriptionStatus = true
                inputField[i].DescriptionMessage = "Belum Diisi"
                statuspass = "tidak pass"
            }else{
                inputField[i].DescriptionStatus = false
                inputField[i].DescriptionMessage = null
            }
            if(inputFields[i].UnitPrice === "" || inputFields[i].UnitPrice === "0"){
                inputField[i].UnitPriceStatus = true
                inputField[i].UnitPriceMessage = "Belum Diisi"
                statuspass = "tidak pass"
            }else{
                inputField[i].UnitPriceStatus = false
                inputField[i].UnitPriceMessage = null
            }
            if(inputFields[i].Tipe === ""){
                inputField[i].TipeStatus = true
                statuspass = "tidak pass"
            }else{
                inputField[i].TipeStatus = false
            }
        }

        if(instruction === "Deposit" || instruction === "-" || instruction === ""){
        }else{
            var i = 0;
            while( i < downPayments.length){
                console.log(downPayments)
                console.log(downPayments[i])
                if(!downPayments[i].Total || downPayments[i].Total === "0"){
                    statuspass = "tidak pass"
                }
                i++
            }
        }
        setInputFields(inputField)
        if(statuspass === "pass"){

            if(passed.state.stuff === "edit"){
            var PINumbnow =  piYear+"."+piMonth+"-PI-ZANIO."+piAmount
            axios.post(`${process.env.REACT_APP_BACKEND_URL}/updatePI`,{
                PINumbnow, inputFields, shipTo, notes, subTotal, sellerID , grandTotal, ppn, address1, address2, address3, phone, totalDate, billTo, instruction, downPayments, pelunasanNotes, pelunasansGrandTotal, ppnPercent, piAmount, bDate
            })

                console.log("create")
                var PINumbnow =  piYear+"."+piMonth+"-PI-ZANIO."+piAmount
                console.log(PINumbnow)
                axios.post(`${process.env.REACT_APP_BACKEND_URL}/renderProformaInvoice`, {
                    inputFields, shipTo, notes, subTotal,sellerID, grandTotal, ppn, address1, address2, address3, phone, totalDate, billTo, instruction, downPayments, pelunasanNotes, pelunasansGrandTotal, PINumbnow
                }, {
                    responseType: "blob"
                }).then(resp => {
                            console.log(resp)
                                const blob = new Blob([resp.data], { type: 'application/pdf' })
                            // saveAs(blob);
                            var fileURLNew = URL.createObjectURL(blob);
                            console.log(fileURLNew)
                            setLoadVisibility(false)
                            window.open(fileURLNew, '_blank');
                            navigate('/pi-list');
                        })
        
                    

            }else{
                e.preventDefault()
                if(passed.state.stuff === "addOn"){
                    const prevPIAmounting = piAmount
                    axios.get(`${process.env.REACT_APP_BACKEND_URL}/latestPINum`).then(response => {
                        console.log(response.data);
                        console.log(response.data.jumlah);
                        var testestest = response.data.jumlah;
                        console.log(testestest);
                        var piAmountNow = parseInt(testestest) + 1;
                        console.log(piAmountNow);
                        setPIAmount(piAmountNow);
                        console.log(piAmount);
                        setPINumb(piYear + "." + piMonth + "-PI-ZANIO." + piAmountNow);
                        console.log(piNumb);
                        var PINumbnow = piYear + "." + piMonth + "-PI-ZANIO." + piAmountNow;
                        console.log({ PINumbnow, piAmountNow });
                        
                        return {PINumbnow,piAmountNow}
                        }).then( res => {
                            console.log(res);
                            const {PINumbnow,piAmountNow} = res
                            console.log(PINumbnow);
                            console.log(piAmountNow);
                            console.log("this is addon")
                    axios.post(`${process.env.REACT_APP_BACKEND_URL}/savePI`,{
                        Inquiry: passed.state.Inquiry, inquiryNum,sellerID, PINumbnow, inputFields, shipTo, notes, subTotal, grandTotal, ppn, address1, address2, address3, phone, totalDate, billTo, instruction, downPayments, pelunasanNotes, pelunasansGrandTotal, ppnPercent, bDate,piAmountNow
                      })
                      .then( res => {
                        console.log("create Addon nowww");
                        const {PINumbnow,piAmountNow} = res.data;
                        // Call the savePrevPI API here
                        axios.post(`${process.env.REACT_APP_BACKEND_URL}/savePrevPI`,{
                          piAmount: piAmountNow, 
                          prevPIAmounting: piAmount// pass your prevPIAmounting value here
                        });
                        // Continue with the rest of your code...
                        return {PINumbnow,piAmountNow};
                      })
                      .then(({PINumbnow, piAmountNow}) => {
                        axios.post(`${process.env.REACT_APP_BACKEND_URL}/renderProformaInvoice`, {
                          inputFields, shipTo, notes, subTotal, sellerID, grandTotal, ppn, address1, address2, address3, phone, totalDate, billTo, instruction, downPayments, pelunasanNotes, pelunasansGrandTotal, PINumbnow
                        }, {
                          responseType: "blob"
                        })
                        .then(resp => {
                          console.log(resp);
                          const blob = new Blob([resp.data], { type: 'application/pdf' });
                          var fileURLNew = URL.createObjectURL(blob);
                          console.log(fileURLNew);
                          setLoadVisibility(false);
                          navigate('/pi-list');
                          window.open(fileURLNew, '_blank');
                        });
                      })
                      .catch(error => {
                        console.error(error);
                      });
                      
                        });
                   

                }else{
                console.log("getting latest PI Num")
                axios.get(`${process.env.REACT_APP_BACKEND_URL}/latestPINum`).then(response => {
                    console.log(response.data);
                    console.log(response.data.jumlah);
                    var testestest = response.data.jumlah;
                    console.log(testestest);
                    var piAmountNow = parseInt(testestest) + 1;
                    console.log(piAmountNow);
                    setPIAmount(piAmountNow);
                    console.log(piAmount);
                    setPINumb(piYear + "." + piMonth + "-PI-ZANIO." + piAmountNow);
                    console.log(piNumb);
                    var PINumbnow = piYear + "." + piMonth + "-PI-ZANIO." + piAmountNow;
                    console.log({ PINumbnow, piAmountNow });
                    
                    return {PINumbnow,piAmountNow}
                    }).then( res => {
                        console.log(res);
                        const {PINumbnow,piAmountNow} = res
                        console.log(PINumbnow);
                        axios.post(`${process.env.REACT_APP_BACKEND_URL}/updateInqOneThing`,{
                            id:  passed.state.Inquiry._id, change:"PIlink"
                        })
                        axios.post(`${process.env.REACT_APP_BACKEND_URL}/sethistoryInq`,{
                            id:  passed.state.Inquiry._id, user: nowstate.user.username
                        })
                        console.log(piAmountNow);
                        axios.post(`${process.env.REACT_APP_BACKEND_URL}/savePI`,{
                            Inquiry: passed.state.Inquiry, inquiryNum, PINumbnow, sellerID, inputFields, shipTo, notes, subTotal, grandTotal, ppn, address1, address2, address3, phone, totalDate, billTo, instruction, downPayments, pelunasanNotes, pelunasansGrandTotal, ppnPercent, bDate,piAmountNow
                        })
                        return {PINumbnow,piAmountNow}
                        }).then( res => {
                            console.log("create")
                            const {PINumbnow,piAmountNow} = res
                            axios.post(`${process.env.REACT_APP_BACKEND_URL}/renderProformaInvoice`, {
                                inputFields, shipTo, notes, subTotal, grandTotal,sellerID, ppn, address1, address2, address3, phone, totalDate, billTo, instruction, downPayments, pelunasanNotes, pelunasansGrandTotal, PINumbnow
                            }, {
                                responseType: "blob"
                            }).then(resp => {
                                        console.log(resp)
                                            const blob = new Blob([resp.data], { type: 'application/pdf' })
                                        // saveAs(blob);
                                        var fileURLNew = URL.createObjectURL(blob);
                                        console.log(fileURLNew)
                                        setLoadVisibility(false)
                                        navigate('/pi-list');
                                        window.open(fileURLNew, '_blank');
                                    })
                    });
                }
            }    
            
    }else{
        setLoadVisibility(false)
        setOpen(true);
    }
            ////////////////////End Of Update PI/////////////////////
        

        

        // if(piAmount === "0"){
        // axios.get(`${process.env.REACT_APP_BACKEND_URL}/latestPINum`,{
        //     }).then(response=>{
        //         console.log(response.data.jumlah[0])
        //         var testestest = response.data.jumlah[0];
        //         console.log(testestest.piAmount);
        //       var piAmountNow = parseInt(testestest.piAmount) + parseInt(1);
        //       console.log(piAmountNow);
        //       setPIAmount(piAmountNow);
        //       console.log(piAmount)
        //       setPINumb(piYear+"."+piMonth+"-PI-SAMUDRA."+piAmountNow);
        //       console.log(piNumb)
        //       var PINumbnow =  piYear+"."+piMonth+"-PI-SAMUDRA."+piAmountNow
        //   })
        //   setTimeout((PINumbnow, piAmountNow)=>{
        //     console.log(piDate + " " + toMonthName(longMonth) + " " + piYear)
        // }
        ///////////////////////////////New PI////////////////////////////////////////

       
    // },5000)
    };

    const handleChangeUnit = (index,event) => {
        const values =[...inputFields];
        values[index].Unit = event.target.value;
        setInputFields(values);
        calPPH();
        
    };

    const [totalPPH42,setTotalPPH42] = useState(0);
    const [totalPPH23,setTotalPPH23] = useState(0);

    const handleChangeTipe = (index,event) => {
        const values =[...inputFields];
        values[index].Tipe = event.target.value;
        calPPH();
        
        
    };

    const calPPH = (index,event) => {
        const values =[...inputFields];
        var pph42Count = 0
        var pph23Count = 0
        if (instruction === "Deposit"){
        }else{
        for (var i  = 0; i < values.length; i++){
            var TipeI = values[i].Tipe
            var currTotal = values[i].Total
            console.log(TipeI)
            if(TipeI == "Sewa"){
                pph42Count = pph42Count + (currTotal * 0.1)
            }

            if(TipeI == "Non-Sewa"){
                pph23Count = pph23Count + (currTotal * 0.02)
            }
            

         }

        }
        
        setTotalPPH42(pph42Count)
        setTotalPPH23(pph23Count)

        if(pph42Count === 0){
            setPPH42Visibility("hidden")
        }else{
            setPPH42Visibility("")
        }

        if(pph23Count === 0){
            setPPH23Visibility("hidden")
        }else{
            setPPH23Visibility("")
        }
        setInputFields(values);
    }

    const [subTotal, setSubTotal] = useState("")
    const [grandTotal, setGrandTotal] = useState("")
    const [ppn, setPPN] = useState("")
    
    const totalChange =  (event) => {
        var subTotal = 0
        var grandTotal = 0
        setTimeout(() => { 
        for (var i  = 0; i < inputFields.length; i++){
            var subtotalI = inputFields[i].Total
            var grandTotalI = inputFields[i].TotalPPN

            if(subtotalI === '' || subtotalI === 0){
                subtotalI = 0 ;
            }

            if(grandTotalI === '' || grandTotalI === 0){
                grandTotalI = 0 ;
            }

            subTotal  += parseFloat(subtotalI);
            grandTotal  += parseFloat(grandTotalI);
            

         }
        subTotal = Math.floor((subTotal)*100)/100
        grandTotal = Math.floor((subTotal * (1+(ppnPercent/100)))*100)/100
        setGrandTotal(grandTotal)
        setSubTotal(subTotal)
        var ppn = Math.floor((subTotal * ((ppnPercent/100)))*100)/100
        setPPN(ppn)

        if (instruction === "Deposit"){
        setSubTotal(subTotal)
        setGrandTotal(subTotal) 
        var ppn = ""
        setPPN(ppn)
        }

        var paidPayments = 0;
        var grandPaidPayments = 0;
        for(var i  = 0; i < downPayments.length; i++){
            paidPayments = parseFloat(paidPayments) + parseFloat(downPayments[i].Total);
            grandPaidPayments = parseFloat(grandPaidPayments) + parseFloat(downPayments[i].GrandTotal);
        }

        var pelunasansubsubtotal = subTotal-paidPayments;
        setPelunasansSubTotal(pelunasansubsubtotal);
        setPelunasansGrandTotal(Math.floor((pelunasansubsubtotal * (1+(ppnPercent/100)))*100)/100);
    }, 100);
    
    }

    const handleChangeAddress = (event) => {
        setAddress1(event.target.value)
        const alamatDicari = event.target.value
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/confirm-address`,{
                alamatDicari
        }).then(response=>{
            console.log(response.data)
            setAddress2(response.data.address2)
            setAddress3(response.data.address3)
            setPhone(response.data.phone)
        });
    };

    const handleChangeInputDesc = (index, event, value) => {
        const values =[...inputFields];
        values[index].Description = value;
        console.log(event);
        setInputFields(values);
    }

    const handleChangeInputDescManual = (index, event) => {
        const values =[...inputFields];
        values[index].Description = event.target.value;
        console.log(event.target.value);
        setInputFields(values);
    }

    async function cancelEdit(e){
        navigate("/pi-list")
    }

    const handleQuantityChangeInput = (index, event) => {
        if(focus === "quantity"){
        const values =[...inputFields];
        values[index][event.target.name] = event.target.value;
        setInputFields(values);
        updateGrandTotalBasedOnQuantity(index,event)
        calPPH();
        }
    }

    const updateGrandTotalBasedOnQuantity = (index, event) => {
        const item =[...inputFields];
        const UnitPriceAmount = item[index].UnitPrice;
        if(UnitPriceAmount === '' || UnitPriceAmount === 0){
            item[index].UnitPrice = 0;
        }
        item[index].Total = parseInt(event.target.value) * item[index].UnitPrice;
        item[index].TotalPPN = Math.floor((item[index].Total * (1+(ppnPercent/100)))*100)/100
        setInputFields(item);
        totalChange();
        calPPH();
    }

    const handleUnitPriceChangeInput = (index, event) => {
        if(focus === "unit-price"){
            const values =[...inputFields];
            values[index][event.target.name] = event.target.value;
            setInputFields(values);
            updateGrandTotalBasedOnUnitPrice(index,event)
            calPPH();
            
        }
    }

    const updateGrandTotalBasedOnUnitPrice = (index, event) => {
        const item =[...inputFields];
        const QuantityAmount = item[index].Quantity;
        if(QuantityAmount === '' || QuantityAmount === 0){
            item[index].Quantity = 1 ;
        }
        item[index].Total = event.target.value * item[index].Quantity;
        item[index].TotalPPN = Math.floor((item[index].Total * (1+(ppnPercent/100)))*100)/100
        setInputFields(item);
        totalChange();
        calPPH();
    }

    const handleTotalChangeInput = (index, event) => {
        if(focus === "total"){
            const values =[...inputFields];
            values[index][event.target.name] = event.target.value;
            setInputFields(values);
            totalChange();
            updateOtherBasedOnTotal(index,event)
            calPPH();

        }
    }

    const handleDownPaymentTotalChangeInput = (index, event) => {
        if(focus === "total"){
            const values =[...downPayments];
            values[index][event.target.name] = event.target.value;
            values[index].GrandTotal = Math.floor((event.target.value * (1+(ppnPercent/100)))*100)/100;
            setDownPayments(values);
            calcPelunasans();

        }
    }

    const handleDownPaymentGrandTotalChangeInput = (index, event) => {
        if(focus === "grandtotal"){
            const values =[...downPayments];
            values[index][event.target.name] = event.target.value;
            values[index].Total = Math.floor((event.target.value - (Math.floor(event.target.value*((1*(1+(ppnPercent/100)) - 1)/(1*(1+(ppnPercent/100))))*100)/100))*100)/100;
            setDownPayments(values);
            calcPelunasans();

        }
    }

    const updateOtherBasedOnTotal = (index, event) => {
        const item =[...inputFields];
        const QuantityAmount = item[index].Quantity;
        const UnitPriceAmount = item[index].UnitPrice;
        item[index].TotalPPN = Math.floor((event.target.value * (1+(ppnPercent/100)))*100)/100;
        if(QuantityAmount === '' || QuantityAmount === 0){
            if(UnitPriceAmount === '' || UnitPriceAmount === 0){
                item[index].Quantity = 1 ;
                
                item[index].UnitPrice = Math.floor((event.target.value / item[index].Quantity)*100)/100;
            }else{
                item[index].Quantity = Math.floor((event.target.value / item[index].UnitPrice)*100)/100;
            }
        }else{
            item[index].UnitPrice = Math.floor((event.target.value / item[index].Quantity)*100)/100;
        }
        setInputFields(item);
        calPPH();
    }

    const handleTotalPPNChangeInput = (index, event) => {
        if(focus === "totalppn"){
            const values =[...inputFields];
            values[index][event.target.name] = event.target.value;
            setInputFields(values);
            updateOtherBasedOnTotalPPN(index,event)
            totalChange();
            calPPH();
        }
    }
    
    
    const handleDateChange = (event) => {
        setbDate(event);
        console.log(event)
        var piDate = new Date(event).getDate();
        var piMonth = new Date(event).getMonth()+1; 
        var longMonth = event.toLocaleString('default', { month: 'long' });
        var piYear = new Date(event).getYear()+1900;
        setTotalDate(piDate + " " + longMonth + " " + piYear);
        const cariJumlahnya = "ProformaInvoice"
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/cariJumlah`,{
            cariJumlahnya
        }).then(response=>{
            console.log(response.data)
          piAmount = response.data;
      });
        setPINumb(piYear+"."+piMonth+"-PI-ZANIO."+piAmount)
    }
    const handleppnPercent = (event) => {
        setppnPercent(parseInt(event.target.value));
        const values =[...inputFields];
        for(var i  = 0; i < inputFields.length; i++){
            values[i].UnitPrice = inputFields[i].UnitPrice;
            values[i].TotalPPN = Math.floor((inputFields[i].Total * (1+(parseInt(event.target.value)/100)))*100)/100;
            setInputFields(values);
            
        }
        var subTotal = 0
        var grandTotal = 0
        setTimeout(() => { 
        for (var i  = 0; i < values.length; i++){
            var subtotalI = values[i].Total
            var grandTotalI = values[i].TotalPPN

            if(subtotalI === '' || subtotalI === 0){
                subtotalI = 0 ;
            }

            if(grandTotalI === '' || grandTotalI === 0){
                grandTotalI = 0 ;
            }

            subTotal  += parseFloat(subtotalI);
            grandTotal  += parseFloat(grandTotalI);
            

         }
        subTotal = Math.floor((subTotal)*100)/100
        grandTotal = Math.floor((subTotal * (1+(parseInt(event.target.value)/100)))*100)/100
        setGrandTotal(grandTotal)
        setSubTotal(subTotal)
        var ppn = Math.floor((subTotal * ((parseInt(event.target.value)/100)))*100)/100
        setPPN(ppn)

        if (instruction === "Deposit"){
        setSubTotal(subTotal)
        setGrandTotal(subTotal) 
        var ppn = ""
        setPPN(ppn)
        }

        var paidPayments = 0;
        var grandPaidPayments = 0;
        for(var i  = 0; i < downPayments.length; i++){
            paidPayments = parseFloat(paidPayments) + parseFloat(downPayments[i].Total);
            grandPaidPayments = parseFloat(grandPaidPayments) + parseFloat(downPayments[i].GrandTotal);
        }

        var pelunasansubsubtotal = subTotal-paidPayments;
        setPelunasansSubTotal(pelunasansubsubtotal);
        setPelunasansGrandTotal(Math.floor((pelunasansubsubtotal * (1+(ppnPercent/100)))*100)/100);
    }, 100);

        

    }

    const updateOtherBasedOnTotalPPN = (index, event) => {
        const item =[...inputFields];
        const QuantityAmount = item[index].Quantity;
        const UnitPriceAmount = item[index].UnitPrice;
        item[index].Total = Math.floor((event.target.value - (Math.floor(event.target.value*((1*(1+(ppnPercent/100)) - 1)/(1*(1+(ppnPercent/100))))*100)/100))*100)/100;
        setInputFields(item);
        if(QuantityAmount === '' || QuantityAmount === 0){
            if(UnitPriceAmount === '' || UnitPriceAmount === 0){
                item[index].Quantity = 1 ;
                
                item[index].UnitPrice = Math.floor((item[index].Total / item[index].Quantity)*100)/100;
            }else{
                item[index].Quantity = Math.floor((item[index].Total / item[index].UnitPrice)*100)/100;
            }
        }else{
            item[index].UnitPrice = Math.floor((item[index].Total / item[index].Quantity)*100)/100;
        }
        setInputFields(item);
        calPPH();

    }

    const handleNotes = (event) => {
        setNotes(event.target.value)
    }

    const handleAddFields = () => {
        setInputFields([...inputFields, {Quantity:'', Unit:'Unit',Description:'',UnitPrice:''}])

    }

    const handleDPAddFields = (index) => {
        const values = [...downPayments]
        values[index].Text = 'Paid Payment' + " " + parseInt(index+1);
        values[index].visibility="hidden";
        setDownPayments(values)
        if (instruction === "DP"){
            setDownPayments([...downPayments, {SubTotal:0, GrandTotal:0, Text:'Down Payment' + " " + parseInt(index+2), visibility:""}])
        }else{setDownPayments([...downPayments, {SubTotal:0, GrandTotal:0, Text:'Paid Payment' + " " + parseInt(index+2), visibility:""}])}
        calcPelunasans()

    }

    const handleDPMinusFields = (index) => {
        const values = [...downPayments]
        const deletedNumberGrandTotal = downPayments[index].GrandTotal;
        const deletedNumberSubTotal = deletedNumberGrandTotal/1.11;
        console.log(deletedNumberSubTotal)
        if(index<1){

        }else{
        values[index-1].visibility="";
        if (instruction === "DP"){
            values[index-1].Text="Down Payment" + " " + parseInt(index);
        }else{
            values[index-1].Text="Paid Payment" + " " + parseInt(index);
        }
        values[index].GrandTotal = 0;
        values[index].SubTotal = 0;
        setDownPayments(values);
        values.splice(index,1);
        setDownPayments(values);        
        calcPelunasans()

        }
    }


    const handleFullPayment = (event) => {
        if(focus === "fullPayment"){
            setFullPayment(event.target.value)
            setFullPaymentPPN(Math.floor((event.target.value * (1+(ppnPercent/100)))*100)/100)
        }
    }

    const handleFullPaymentPPN = (event) => {
        if(focus === "fullPaymentPPN"){
            setFullPaymentPPN(event.target.value)
            setFullPayment(Math.floor((event.target.value / (1+(ppnPercent/100)))*100)/100)
        }
    }

    const handleMinusFields = (index) => {
        const values = [...inputFields]
        if(index<1){

        }else{
        values[index].UnitPrice = 0;
        values[index].Total = 0;
        values[index].TotalPPN = 0;
        values[index].Quantity = 0;
        setInputFields(values);
        values.splice(index,1);
        setInputFields(values);        
        setInputFields(values);
        totalChange();      
        calcPelunasans();

        
        }
    }
    const [sellerID,setSellerID]= useState("PT. SUPARDI NETHANEL HUSAIN");
    
    const handleChange = (event) => {
        setSellerID(event.target.value);
        var ppnmau = "11"
        if(event.target.value=== "PT. SUPARDI NETHANEL HUSAIN"){
            ppnmau = "11";
        }else{
            ppnmau = "0";
        }
        setppnPercent(parseInt(ppnmau));
        const values =[...inputFields];
        for(var i  = 0; i < inputFields.length; i++){
            values[i].UnitPrice = inputFields[i].UnitPrice;
            values[i].TotalPPN = Math.floor((inputFields[i].Total * (1+(parseInt(ppnmau)/100)))*100)/100;
            setInputFields(values);
            
        }
        var subTotal = 0
        var grandTotal = 0
        setTimeout(() => { 
        for (var i  = 0; i < values.length; i++){
            var subtotalI = values[i].Total
            var grandTotalI = values[i].TotalPPN

            if(subtotalI === '' || subtotalI === 0){
                subtotalI = 0 ;
            }

            if(grandTotalI === '' || grandTotalI === 0){
                grandTotalI = 0 ;
            }

            subTotal  += parseFloat(subtotalI);
            grandTotal  += parseFloat(grandTotalI);
            

         }
        subTotal = Math.floor((subTotal)*100)/100
        grandTotal = Math.floor((subTotal * (1+(parseInt(ppnmau)/100)))*100)/100
        setGrandTotal(grandTotal)
        setSubTotal(subTotal)
        var ppn = Math.floor((subTotal * ((parseInt(ppnmau)/100)))*100)/100
        setPPN(ppn)

        if (instruction === "Deposit"){
        setSubTotal(subTotal)
        setGrandTotal(subTotal) 
        var ppn = ""
        setPPN(ppn)
        }

        var paidPayments = 0;
        var grandPaidPayments = 0;
        for(var i  = 0; i < downPayments.length; i++){
            paidPayments = parseFloat(paidPayments) + parseFloat(downPayments[i].Total);
            grandPaidPayments = parseFloat(grandPaidPayments) + parseFloat(downPayments[i].GrandTotal);
        }

        var pelunasansubsubtotal = subTotal-paidPayments;
        setPelunasansSubTotal(pelunasansubsubtotal);
        setPelunasansGrandTotal(Math.floor((pelunasansubsubtotal * (1+(ppnPercent/100)))*100)/100);
    }, 100);
      };

    const calcPelunasans = () => {
        var paidPayments = 0;
        var grandPaidPayments = 0;
        for(var i  = 0; i < downPayments.length; i++){
            paidPayments = parseFloat(paidPayments) + parseFloat(downPayments[i].Total);
            grandPaidPayments = parseFloat(grandPaidPayments) + parseFloat(downPayments[i].GrandTotal);
        }

        var pelunasansubsubtotal = subTotal-paidPayments;
        var pelunasangrandgrandtotal = grandTotal-grandPaidPayments;
        setPelunasansSubTotal(pelunasansubsubtotal);
        setPelunasansGrandTotal(Math.floor((pelunasansubsubtotal * (1+(ppnPercent/100)))*100)/100);
    }

    const color = "#FFFFFF";
    
    return <Grid container>
                <Dialog open={loadVisibility} aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "100px",  // Set your width here
                        },
                    },}}>
                    <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        <LinearProgress />
                    </Box>
                    </DialogContent>
                </Dialog>
                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                    {"Warning!"}
                    </DialogTitle>
                    <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                       Terdapat data yang belum kamu isi diatas.
                    </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                    <Button onClick={handleClose} autoFocus>
                        Oke
                    </Button>
                    </DialogActions>
                </Dialog>
                <Grid item xl={0.5} lg={0.7} md={0.9} sm={0.8} className="leftmenucolor">
                    <LeftMenu/>
                </Grid>
                <Grid item xl={10.8} lg={10.6} md={10.4} sm={10.5}>
                    <Grid className="boxshadowclass" position="fixed" width="98%" xs={12} zIndex="100" opacity="1">
                        <Header></Header>
                    </Grid>
                    <Grid sx={{ mt:15}}>
                    <form>
                    <Grid sm={12}>
                    <Grid container>
                        <Grid item sm={5.5}>
                            <Grid sx={{ mt:10}} marginLeft={{lg:5, md:5}}>
                            <div>
                                <FormControl>
                                    <InputLabel id="company-select-label">Company</InputLabel>
                                    <Select
                                    labelId="company-select-label"
                                    id="company-select"
                                    value={sellerID}
                                    onChange={handleChange}
                                    >
                                    <MenuItem value="PT. SUPARDI NETHANEL HUSAIN">PT. SUPARDI NETHANEL HUSAIN</MenuItem>
                                    <MenuItem value="PT. KENDALI MITRA SUKSES">PT. KENDALI MITRA SUKSES</MenuItem>
                                    </Select>
                                </FormControl>
                                </div>
                                <Select value={address1} error={alamatStatus} helperText={alamatMessage} whiteSpace="normal" onChange={event => handleChangeAddress(event)}>{categorias.map((categoria) =><MenuItem multiline value={categoria}>{categoria}</MenuItem>)}</Select>
                                <p style={{fontSize: 15}}><b>{address2}</b></p>
                                <p style={{fontSize: 15}}><b>{address3}</b></p>
                            </Grid>
                            <Grid sx={{ mt:5}} marginLeft={{lg:5, md:5}}>
                                <p style={{fontSize: 15}}><b>Phone:</b>{phone}</p>
                            </Grid>
                        </Grid>
                        <Grid sm={6} sx={{ mt:5, display:{ lg: 'block', md: 'none' }}} paddingLeft={{lg:5, md:0}}>
                            <img width="30%" sm={12} src="/images/logo/SamudraLogoDefault.jpeg"/>
                            <p sm={12} fontSize="15px">PROFORMA INVOICE</p>
                        </Grid>
                    </Grid>

                    <Grid container sx={{ mt:5}} paddingLeft={{lg:5, md:5}}>
                        <Grid item sm={2.67} fontSize="14px" backgroundColor="#577188" sx={{pl:2, pt:2}}  color="#FFFFFF"><p>INVOICE NO:</p></Grid>
                        <Grid item sm={2.67} fontSize="14px" backgroundColor="#577188" sx={{pt:2}}  color="#FFFFFF" onLoad= {() => trial()}><p>{piNumb}</p></Grid>
                        <Grid item sm={2.67} fontSize="14px" backgroundColor="#577188" sx={{}}  color="#FFFFFF"><LocalizationProvider color="#FFFFFF" dateAdapter={AdapterDateFns}>
                    <MobileDatePicker views={['day','month', 'year']} color="#FFFFFF" inputFormat="dd/MM/yyyy"
                        placeholder="Tanggal"
                        value={bDate}
                        onChange={(event) => {
                            handleDateChange(event);
                        }}
                        renderInput={(params) => <TextField fullWidth sx={{svg:{color}, input:{color}, placeholder:{color},}}  {...params} InputProps={{endAdornment: (
                        <InputAdornment color="#FFFFFF" position="end">
                            <CalendarMonthIcon />
                        </InputAdornment>
                    ),
                    }}/>}

                        />
                        </LocalizationProvider></Grid>
                    </Grid>
                    <Grid container sx={{ mt:2}} paddingLeft={{lg:5, md:5}}>
                        <Grid item sm={2.67} fontSize="14px" sx={{pl:2, pt:2}}><p>Bill To</p></Grid>
                        <Grid item sm={2.67} fontSize="14px" sx={{pt:2}} ><p color="white">Ship To</p></Grid>
                        <Grid item sm={2.67} fontSize="14px"sx={{pt:2}} ><p color="white">Instructions</p></Grid>
                    </Grid>
                    <Grid container paddingLeft={{lg:5, md:5}}>
                        <Grid item sm={2.67} fontSize="14px" sx={{pt:2, pl:2}} ><TextField multiline error={billtoStatus} helperText={billtoMessage} sm={2.67} fontSize="14px" name="Quantity" placeholder="PT/CV" value={billTo} onChange={event => handleBillTo(event)}/></Grid>
                        <Grid item sm={2.67} fontSize="14px" sx={{pt:2}} ><TextField multiline error={shiptoStatus} helperText={shiptoMessage} sm={2.67} fontSize="14px" name="Quantity" placeholder="Mr/Ms" value={shipTo} onChange={event => handleShipTo(event)}/></Grid>
                        <Grid item sm={2.67} fontSize="14px" sx={{pt:2}} ><Select multiline error={instructionStatus} helperText={instructionMessage} value={instruction} sm={2.67} fontSize="14px" onChange={event => handleInstruction(event)}><MenuItem value="-">-</MenuItem><MenuItem value="DP">DP</MenuItem><MenuItem value="Deposit">Deposit</MenuItem><MenuItem value="Pelunasan">Pelunasan</MenuItem></Select></Grid>
                    </Grid>
                    <Grid container sx={{ mt:2}} paddingLeft={{lg:5, md:5}}>
                        <Grid item sm={1.5} fontSize="14px" backgroundColor="#577188" sx={{pl:2, pt:2}}  color="#FFFFFF"><p>Quantity</p></Grid>
                        <Grid item sm={2.5} fontSize="14px" backgroundColor="#577188" sx={{pt:2}}  color="#FFFFFF"><p>Description</p></Grid>
                        <Grid item sm={2} fontSize="14px" backgroundColor="#577188" sx={{pt:2}}  color="#FFFFFF"><p>Unit Price</p></Grid>
                        <Grid item sm={2} fontSize="14px" backgroundColor="#577188" sx={{pt:2}}  color="#FFFFFF"><p>Total</p></Grid>
                    </Grid>
                    </Grid>
                        {inputFields.map((inputField, index) =>(
                            <div key={index}> 
                            <Grid container sx={{ mt:2}} paddingLeft={{lg:5, md:5}}>
                                <Grid container sm={1.5} fontSize="14px" sx={{pt:2}}>
                                    <Grid sm={4.5}>
                                        <TextField multiline error={inputField.QuantityStatus} helperText={inputField.QuantityMessage} type="number" onFocus={event => setFocus("quantity")} sm={3.2} name="Quantity" placeholder="1" value={inputField.Quantity} onChange={event => handleQuantityChangeInput(index, event)}/>
                                    </Grid>
                                    <Grid sm={7.5}>
                                        <Select multiline error={inputField.UnitStatus} helperText={inputField.UnitMessage} value={inputFields[index].Unit} onChange={event => handleChangeUnit(index, event)}><MenuItem value="Unit">Unit</MenuItem><MenuItem value="Jam">Jam</MenuItem><MenuItem value="Hari">Hari</MenuItem><MenuItem value="Minggu">Minggu</MenuItem><MenuItem value="Bulan">Bulan</MenuItem><MenuItem value="Tahun">Tahun</MenuItem></Select>
                                    </Grid>
                                </Grid>
                                <Grid item sm={2.5} fontSize="14px" sx={{pt:2, pr:1}}>
                                    <Autocomplete 
                                        value={inputField.Description}
                                        freeSolo 
                                        id="free-solo-2-demo"
                                        disableClearable
                                        options={product.map((option) => option.product)}
                                        onChange={(event,value) => handleChangeInputDesc(index, event, value)}
                                        renderInput={(params) => (
                                        <TextField  multiline error={inputField.DescriptionStatus} helperText={inputField.DescriptionMessage}
                                            {...params}
                                            label="Description"
                                            InputProps={{
                                            ...params.InputProps,
                                            type: 'search',
                                            }} 
                                            onChange={event => handleChangeInputDescManual(index, event)}
                                        />
                                        )}
                                    />
                                </Grid>
                                <Grid item sm={2} fontSize="14px" sx={{pt:2 , pr:1}}>
                                    <TextField multiline error={inputField.UnitPriceStatus} label="Unit Price" helperText={inputField.UnitPriceMessage} id="outlined-error-helper-text" onFocus={event => setFocus("unit-price")} InputProps={{inputComponent: NumberFormatCustom, endAdornment: <InputAdornment position="start">/{inputFields[index].Unit}</InputAdornment>}} name="UnitPrice" placeholder="Unit Price" value={inputField.UnitPrice} onChange={event => handleUnitPriceChangeInput(index, event)}/>
                                
                                </Grid>
                                <Grid item sm={2} fontSize="14px" sx={{pt:2, pr:1.5}}>
                                    <TextField multiline  onFocus={event => setFocus("total")} label="Sebelum PPN" InputProps={{inputComponent: NumberFormatCustom,}} name="Total" placeholder="Total" value={inputField.Total} onChange={event => handleTotalChangeInput(index, event)}/>
                                </Grid>
                                <Grid item sm={1.5} fontSize="14px" sx={{pt:2, pr:0.5}}>
                                    <TextField multiline  onFocus={event => setFocus("totalppn")} label="Include PPN" InputProps={{inputComponent: NumberFormatCustom,}} name="TotalPPN" placeholder="Total + PPN" value={inputField.TotalPPN} onChange={event => handleTotalPPNChangeInput(index, event)} />
                                </Grid>
                                <Grid item sm={1} fontSize="10px" sx={{pt:2}}>
                                    <Select value={inputFields[index].Tipe} error={inputField.TipeStatus} onChange={event => handleChangeTipe(index, event)}><MenuItem value="Sewa">Sewa</MenuItem><MenuItem value="Non-Sewa">Non-Sewa</MenuItem></Select>
                                </Grid>
                                <Grid item sm={1} fontSize="14px" sx={{pt:1, pr:1}}>
                                        <Button size="small" type="button" onClick={() => handleAddFields(index)} variant="contained"><AddIcon></AddIcon></Button>
                                        <RedButton size="small" type="button" onClick={() => handleMinusFields(index)} variant="contained"><RemoveIcon></RemoveIcon></RedButton>
                                </Grid>
                            </Grid>
                                
                                
                            </div>
                        ))}
                        <Grid container sx={{ mt:5}} paddingLeft={{lg:5, md:5}}>
                            <Grid sm={4}>
                            </Grid>
                            <Grid sm={2} fontSize="14px" sx={{ pl:2, pt:2  }}>
                                <p>Sub-Total:</p>
                            </Grid>
                            <Grid sm={2} fontSize="14px" >
                                <TextField InputProps={{inputComponent: NumberFormatCustom,}} disabled value={subTotal} variant="filled"/>
                            </Grid>
                        </Grid>
                        {
                        sellerID === "PT. SUPARDI NETHANEL HUSAIN" &&
                        <Grid container sx={{ mt:5}} paddingLeft={{lg:5, md:5}} visibility={ppnVisibility}>
                            <Grid sm={4}>
                            </Grid>
                            <Grid sm={2} fontSize="14px" sx={{ pl:2, pt:2  }}>
                                <p>PPN:</p>
                            </Grid>
                            <Grid sm={2} fontSize="14px" >
                                <TextField InputProps={{inputComponent: NumberFormatCustom,}} disabled value={ppn} variant="filled"/>
                            </Grid>
                            <Grid sm={2}>
                            <FormControl focused className="col " variant="outlined">
                            <InputLabel className="mText">PPN %</InputLabel>
                            <NumberFormat customInput={TextField} 
                                variant="outlined"
                                thousandSeparator={true}
                                suffix={'%'}
                                value={ppnPercent}
                                onChange={event => handleppnPercent(event)}
                                autoComplete="off"/>
                            </FormControl>
                            </Grid>
                        </Grid>
                        }
                        <Grid container sx={{ mt:5}} paddingLeft={{lg:5, md:5}}>
                            <Grid sm={4}>
                            </Grid>
                            <Grid sm={2} fontSize="16px" sx={{ pl:2, pt:2}}>
                                <p><b>Grand Total:</b></p>
                            </Grid>
                            <Grid sm={2} fontSize="16px">
                                <TextField InputProps={{inputComponent: NumberFormatCustom, style:{fontWeight: 'bold', fonrSize:"16px"}}} disabled value={grandTotal} variant="filled"></TextField>
                            </Grid>
                            <Grid sm={2.5}>
                            </Grid>
                        </Grid>
                        <Grid container sx={{ mt:5}} paddingLeft={{lg:5, md:5}}>
                            <Grid sm={10.5} sx={{borderBottom: 2}}>
                            </Grid>
                        </Grid>
                        {downPayments.map((downPayment, index) =>(
                            <Grid container sx={{ mt:5}} paddingLeft={{lg:5, md:5}} visibility={dpNotes}>
                                <Grid sm={4}>
                                </Grid>
                                <Grid sm={2} fontSize="14px" sx={{ pl:2, pt:3}}>
                                    <p>{downPayment.Text}:</p>
                                </Grid>
                                <Grid sm={2} fontSize="14px" sx={{pt:1}}>
                                    <TextField multiline  onFocus={event => setFocus("total")} label="Sebelum PPN" InputProps={{inputComponent: NumberFormatCustom,}} name="Total" placeholder="Total" value={downPayment.Total} onChange={event => handleDownPaymentTotalChangeInput(index, event)}/>
                                </Grid>
                                <Grid sm={2} fontSize="14px" sx={{pt:1}}>
                                    <TextField multiline  onFocus={event => setFocus("grandtotal")} label="Include PPN" InputProps={{inputComponent: NumberFormatCustom,}} name="GrandTotal" placeholder="GrandTotal" value={downPayment.GrandTotal} onChange={event => handleDownPaymentGrandTotalChangeInput(index, event)}/>
                                </Grid>
                                <Grid item sm={1} fontSize="14px" sx={{pr:1}} visibility={downPayment.visibility}>
                                        <Button size="small" type="button" onClick={() => handleDPAddFields(index)} variant="contained"><AddIcon></AddIcon></Button>
                                        <RedButton size="small" type="button" onClick={() => handleDPMinusFields(index)} variant="contained"><RemoveIcon></RemoveIcon></RedButton>
                                </Grid>
                            </Grid>     
                        ))}
                            <Grid container sx={{ mt:5}} paddingLeft={{lg:5, md:5}} visibility={pelunasanNotes}>
                                <Grid sm={4}>
                                </Grid>
                                <Grid sm={2} fontSize="16px" sx={{ pl:2, pt:2}}>
                                    <p><b>Pelunasan:</b></p>
                                </Grid>
                                <Grid sm={2} fontSize="16px">
                                    <TextField InputProps={{inputComponent: NumberFormatCustom, style:{fontWeight: 'bold', fonrSize:"16px"}}} disabled value={pelunasansSubTotal} variant="filled"></TextField>
                                </Grid>
                                <Grid sm={2} fontSize="16px">
                                    <TextField InputProps={{inputComponent: NumberFormatCustom, style:{fontWeight: 'bold', fonrSize:"16px"}}} disabled value={pelunasansGrandTotal} variant="filled"></TextField>
                                </Grid>
                                <Grid sm={2.5}>
                                </Grid>
                            </Grid>
                        <Grid visibility={pph42Visibility} sm={5} sx={{ mt:0, mb:0 }} marginLeft={{lg:5, md:5}} fontSize="14px" >
                                <p>PPH 4(2): Rp. {totalPPH42}</p>
                        </Grid>
                        <Grid visibility={pph23Visibility} sm={5} sx={{ mt:0, mb:0 }} marginLeft={{lg:5, md:5}} fontSize="14px" >
                                <p>PPH23: Rp. {totalPPH23}</p>
                        </Grid>
                        <Grid sm={5} sx={{ mt:10, mb:10 }} marginLeft={{lg:5, md:5}} fontSize="14px" >
                                <p>Notes Tambahan:</p>
                                <TextareaAutosize  style={{ minHeight:"200px", width: "100%" }} value={notes} onChange={event => handleNotes(event)} />
                        </Grid>
                       
                        <Grid container sx={{ mt:10, mb:10 }}  marginLeft={{lg:5, md:5}}>
                            <Grid sm={1}></Grid>
                            <Button type="button" variant="contained" onClick={createAndDownloadPdf}>Save & Download</Button>
                            <Grid sm={1}></Grid>
                            <RedButton type="button" variant="contained" onClick={cancelEdit}>Cancel</RedButton>
                            <Grid sm={1}></Grid>
                            {error && <div className="error_text">{error}</div>}
                        </Grid>
                    </form>
                </Grid>
                </Grid>
            </Grid>
    };